import { Directive, EventEmitter, Output } from '@angular/core';

@Directive({
  selector: '[appHammertime]',
})
export class HammertimeDirective {
  @Output() swipeleft: EventEmitter<any> = new EventEmitter();
  @Output() swiperight: EventEmitter<any> = new EventEmitter();

  constructor() {}
}
